import * as React from 'react';
import { Lazyloader } from '../Lazyloader/Lazyloader';
import type { NewsArticlePage } from '../Types';

export interface IRelatedNewsProps {
    items: NewsArticlePage[];
}

export class RelatedNews extends React.Component<IRelatedNewsProps> {
    private url: string;

    constructor(props: IRelatedNewsProps) {
        super(props);
    }

    public renderItem(item: NewsArticlePage, index: number): JSX.Element {
        return (
            <div className="col-12 col-md-6 col-lg-12 news-module__news-box news-module--grey-box" key={index}>
                <a href={item.url} className="fold fold--orange">
                    {item.image && <Lazyloader image={item.image} hasVideo={item.hasVideo} isBackgroundImage={false} />}
                    <div className="news-module__text news-module--text">
                        <h4>{item.title}</h4>
                        <div className="news-module__text-summary">
                            {item.newsCategory ? <span className="news-module__news-category">{item.newsCategory} · </span> : null}
                            {item.summary}
                        </div>
                    </div>
                </a>
            </div>
        );
    }

    public render(): JSX.Element {
        if (this.props.items == null) {
            return null;
        }
        return (
            <div className="row">
                <div className="col-12">
                    <h2>Läs även</h2>
                </div>
                {this.props.items.map(this.renderItem)}
            </div>
        );
    }
}
